import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchACHFundTransaction from '@/hooks/useApi/useFetchACHFundTransaction';
import AchFundingTransactionInfo from './ACHFundingTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type AchFundingTransactionProps = {
  TransactionID: string;
  Notes: string;
};

type FC = FunctionComponent<AchFundingTransactionProps>;

const AchFundingTransactionContainer: FC = (props: AchFundingTransactionProps) => {
  const { TransactionID, Notes } = props;
  const { userSettings } = useUserSettingsProvider();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.ACHFundTransactionResponse>();
  const [achFundTransaction, getAchFundTransaction, resetTransactionsId] = useFetchACHFundTransaction({ bearer: '' });

  useEffect(() => {
    getAchFundTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (achFundTransaction) {
      setTransaction(achFundTransaction);
    }
  }, [achFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return <div>{transaction && <AchFundingTransactionInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default AchFundingTransactionContainer;
